import { useLang } from 'hooks/lang';

import { loaders } from 'entities';

import { Button, Row } from 'components/Blocks';

import { useToggleV2 } from 'hooks';
import { useOnScreen } from 'hooks/isOnScreen';

import { getBaseQuery } from './utils';

import { ProjectTab } from '..';
import { LoadConfigState } from './types';

interface LoadMoreButtonProps {
  children?: never;
  setProjects: (newData: Pick<LoadConfigState, 'projects' | 'paginationToken'>) => void;
  tab: ProjectTab;
  state: LoadConfigState;
}

const API_PAGE_LENGTH = 30;

export function LoadMoreButton({ setProjects, tab, state }: LoadMoreButtonProps) {
  const { t } = useLang();

  const [hasEnded, endedHandles] = useToggleV2();

  // TODO: fix paginations in our hook creator
  // generate all loaders as imperative calls so we can use them
  // similar to `actions`
  const { loading, retry } = loaders.projects.listProjectsByStatus.use({
    params: getBaseQuery(tab, state),

    blockLoad: true,

    unique: true,

    onDataChange: ({ paginationToken, projects }) => {
      if (projects.length) {
        setProjects({
          paginationToken: paginationToken ?? null,
          projects: [...state.projects, ...projects],
        });
      }

      if (!projects.length || !paginationToken) return endedHandles.turnOn();
    },
  });

  const [, ref] = useOnScreen({
    bottomDistance: 35,

    onVisibilityChange: (isVisible) => {
      if (loading || hasEnded) return;

      if (isVisible) retry();
    },
  });

  return (
    <Row justifyContent="center">
      {state.projects.length >= API_PAGE_LENGTH && !hasEnded && (
        <Button ref={ref} disabled={loading} onClick={retry} loading>
          {loading ? t('loading') : t('load-more')}
        </Button>
      )}
    </Row>
  );
}
